import Stack from "@mui/material/Stack";

import { TracksWeb } from "./TracksWeb";

export const TopInnoTracks = () => {
   const rows = [
      {
         img: "./assets/media/Rectangle 259.png",
         content: (
            <Stack spacing={1}>
               <h2 style={{ color: "blue" }}>1-on-1 Networking Sessions</h2>
               <h5>
                  Connect and meet with active investors over the course of two days
                  leveraging our matchmaking app and conferencing solutions
               </h5>
            </Stack>
         ),
      },
      {
         img: "./assets/media/Rectangle 260.png",
         content: (
            <Stack spacing={1}>
               <h2 style={{ color: "blue" }}>Top Innovator Presentation Slot</h2>
               <h5>
                  Gain visibility for your venture by presenting live to an audience
                  of investors, strategics, press, and being recognized as one of the
                  Top Innovators
               </h5>
            </Stack>
         ),
      },
      {
         img: "./assets/media/Rectangle 261.png",
         content: (
            <Stack spacing={1}>
               <h2 style={{ color: "blue" }}>
                  Featured Company Coaching Session
               </h2>
               <h5>
                  Opportunity to present to active investors and receive crucial
                  feedback that will help you improve your game for the main
                  presentation.
               </h5>
            </Stack>
         ),
      },
      {
         img: "./assets/media/Rectangle 262.png",
         content: (
            <Stack spacing={1}>
               <h2 style={{ color: "blue" }}>Featured Company Profiles</h2>
               <h5>
                  Presenters have their 2 page company profile included in the event
                  guide which is distributed to all attendees and investors.
               </h5>
            </Stack>
         ),
      },
      {
         img: "./assets/media/Rectangle 263.png",
         content: (
            <Stack spacing={1}>
               <h2 style={{ color: "blue" }}>Investor Panels + Round Tables</h2>
               <h5>
                  Watch and hear interactive sessions, where leading investors and
                  experts will discuss key issues facing startups and venture
                  investors alike.
               </h5>
            </Stack>
         ),
      },
   ];
   const deadline = new Date('Nov 11 2022 00:00:00 EST');

   return (
      <>
         <main style={{
            //to have the apply button the same background color as the rest of the div
            backgroundImage: "linear-gradient(white 90%, black 10%)",
            color: "black",
         }}>
            <div style={{ position: "relative" }}>
               <img
                  alt='group-of-poeple'
                  src={window.innerWidth < 900 ? "./assets/media/Group 177 (1).png" : "./assets/media/Group 176.png"}
                  style={{ width: "100%", height: "auto" }}
               />

               {deadline > new Date() &&
                  <a href="https://account.youngstartup.com" target="_blank" rel='noreferrer'>
                     {" "}
                     {window.innerWidth < 900 ? <img
                        alt='Deadline for Top Innovators' src={window.innerWidth < 900 ? "./assets/events/fvs22/Deadline for Top Innovators Splash Image Mobile (1).png" : "./assets/events/fvs22/Deadline for Top Innovators Splash Imag (2).png"}
                        style={{
                           position: "absolute",
                           top: "0",
                           right: "0",
                           width: "60%",
                        }}
                     /> : <img
                        alt='Deadline for Top Innovators' src={window.innerWidth < 900 ? "./assets/events/fvs22/Deadline for Top Innovators Splash Image Mobile (1).png" : "./assets/events/fvs22/Deadline for Top Innovators Splash Image (2).png"}
                        style={{
                           position: "absolute",
                           top: "0",
                           left: "0",
                           width: "40%",
                        }}
                     />}
                  </a>
               }

            </div>
            <Stack>
               <h1 style={{ textAlign: "center", padding: "3% 0% .5% 0%" }}>
                  Featured Company Benefits include:
               </h1>
               <div style={{ padding: "0% 10%" }}>
                  {rows.map((row, i) => {
                     return (
                        <div
                           key={i}
                           style={{
                              display: "flex",
                              borderTop: (i !== 0 && window.innerWidth) > 900 && "1px solid gray",
                              borderBottom: (i = rows.length && window.innerWidth) > 900 && "1px solid gray",
                              padding: "2.5% 0%",
                              alignItems: 'center',
                              flexDirection: window.innerWidth < 900 && "column"
                           }}
                        >
                           <div style={{ flex: 1 }}>
                              <img alt='meeting' src={row.img} style={{ width: '100%', maxWidth: '550px' }} />
                           </div>
                           <div style={{ flex: 1, padding: "5% 10%" }}>
                              {row.content}
                           </div>
                        </div>
                     );
                  })}
               </div>
            </Stack>

            <TracksWeb />
            <br />
         </main>
      </>
   );
};
